import { Badge } from 'antd'
import { Card } from 'antd-mobile'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { getText } from '../../../../utils/util'
import './index.css'

export default function CenterPage({ listData, readAll, delAll, readOne, delOne }) {
  const navigate = useNavigate()
  const { t: translate } = useTranslation()
  const la = localStorage.getItem('i18n')

  // console.log('faith=============listData', listData)
  return (
    <div className="min-h-screen bg-neutral-900 p-4">
      {/* list */}
      <div className="space-y-3">
        {listData.map((data) => (
          <div className="animate-fade-in" key={data.id}>
            {data[la === 'zh' ? 'content' : 'contentEn'] && (
              <div className="rounded-lg bg-neutral-800 p-4 shadow-card hover:bg-neutral-700 transition-all duration-200">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center space-x-2">
                    <Badge 
                      count={data.status == 1 ? 2 : 0} 
                      offset={[5, 0]} 
                      dot 
                      size="default"
                      className="transform scale-90"
                    >
                      <span className="text-neutral-100 font-medium">
                        {data[la === 'zh' ? 'title' : 'titleEn']}
                      </span>
                    </Badge>
                  </div>
                  <span className="text-xs text-neutral-400">
                    {data.addtime}
                  </span>
                </div>
                <div className="text-sm text-neutral-300 leading-relaxed">
                  {data[la === 'zh' ? 'content' : 'contentEn']}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* empty state */}
      {listData.length === 0 && (
        <div className="flex flex-col items-center justify-center min-h-[400px] animate-fade-in">
          <div className="w-32 h-32 mb-4 opacity-80">
            <img 
              alt="" 
              src="/noice/empty-image-default.png" 
              className="w-full h-full object-contain"
            />
          </div>
          <p className="text-neutral-400 text-sm">
            {translate(getText('無留言記錄'))}
          </p>
        </div>
      )}
    </div>
  )
}
